import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AuthService } from "../../authentication/auth.service";
import { ApiServiceBase } from "../../base/api-service-base";
import { FormOfPaymentIssuerReferenceCommandModel, FormOfPaymentIssuerReferenceModel, FormOfPaymentIssuerSearch, FormOfPaymentIssuerSort, FormOfPaymentIssuerUpdateSortSequence, FormOfPaymentTypeReferenceModel } from "../../models/form-of-payment-model";

@Injectable({
    providedIn: 'root'
})
export class FormOfPaymentIssuerReferenceService extends ApiServiceBase {
    private readonly PATH = '/system/FormOfPaymentIssuerReferences';
    constructor(httpClient: HttpClient, authService: AuthService) {
        super(httpClient, authService);
    }

    
    public updateStatusCode(formOfPaymentIssuerCode: string, statusCode: string): Observable<never> {
        return this.httpPut<never>(this.PATH + '/updatestatus/' + formOfPaymentIssuerCode + '/' + statusCode, null )
            .pipe(
                map(res => res.body)
            )
    }

    public search(statusCode?: string, formOfPaymentIssuerName?: string, formOfPaymentIssuerCode?: string): Observable<FormOfPaymentIssuerSearch[]> {
        const queryParams = new HttpParams({ fromObject: <any>{ statusCode, formOfPaymentIssuerName, formOfPaymentIssuerCode } })
        return this.httpGet<FormOfPaymentIssuerSearch[]>(`${this.PATH}/search`, queryParams)
            .pipe(
                map(res => res.body)
            )
    } 
    
    public get(formOfPaymentIssuerCode: string): Observable<FormOfPaymentIssuerReferenceModel> {
        return this.httpGet<FormOfPaymentIssuerReferenceModel>(this.PATH + "/code/" + formOfPaymentIssuerCode, null)
            .pipe(
                map(res => res.body)
            )
    }
    
    public add(command: FormOfPaymentIssuerReferenceCommandModel): Observable<FormOfPaymentIssuerReferenceModel> {
        return this.httpPost<FormOfPaymentIssuerReferenceModel>(this.PATH, command)
            .pipe(
                map(res => res.body)
            )
    }

    public edit(command: FormOfPaymentIssuerReferenceCommandModel): Observable<FormOfPaymentIssuerReferenceModel> {
        return this.httpPut<FormOfPaymentIssuerReferenceModel>(this.PATH, command)
            .pipe(
                map(res => res.body)
            )
    }
    
    public getSort(): Observable<FormOfPaymentIssuerSort[]> {
        return this.httpGet<FormOfPaymentIssuerSort[]>(this.PATH + "/sort", null)
            .pipe(
                map(res => res.body)
            )
    }
    
    public updateSortSequence(items: FormOfPaymentIssuerUpdateSortSequence[]): Observable<never> {
        return this.httpPut<never>(this.PATH + "/sort", items)
            .pipe(
                map(res => res.body)
            )
    }    
}